import * as React from 'react';

import { filterMap } from '@acceligentllc/shared/utils/array';

import { bemElement } from 'af-utils/bem.util';

import TableButtonType from 'ab-enums/tableButtonType.enum';

import { Button } from '@acceligentllc/storybook';

import SubmitButton from 'af-components/SubmitButton';

import type TableTypeEnum from '../../tableType.enum';
import type { ButtonData } from '../../types';

interface OwnProps {
	buttons: ButtonData[];
	tableType: TableTypeEnum;
	exportAsZip?: boolean;
}

type Props = OwnProps;

const buttonHasPermission = (button: ButtonData) => button.hasPermission;

const Buttons: React.FC<Props> = (props) => {

	const { exportAsZip = false, buttons } = props;

	const renderButton = React.useCallback(({ type, onClick, label, icon, actionKey }: ButtonData) => {

		const key = `${type}#${label}`;

		switch (type) {
			case TableButtonType.LINK:
				return (
					<Button
						icon={icon}
						key={key}
						label={label ?? ' '}
						onClick={onClick}
						style="link"
					/>
				);
			case TableButtonType.EXPORT:
				return (
					<Button
						icon="ActionDownload"
						key={key}
						label={`Export as ${exportAsZip ? 'ZIP' : 'CSV'}`}
						onClick={onClick}
						style="link"
					/>
				);
			case TableButtonType.PRIMARY:
			default:
				return (
					<SubmitButton
						icon={icon}
						label={label ?? ''}
						onClick={onClick}
						submitKey={actionKey}
						variant="primary"
					/>
				);
		}
	}, [exportAsZip]);

	return (
		<div className={bemElement('table-container', 'buttons')}>
			{filterMap(buttons, buttonHasPermission, renderButton)}
		</div>
	);
};

export default React.memo(Buttons);
